const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-lock",
  "data-name": "Icon ionic-ios-lock",
  d: "M22.5,11.475H21.15V8.848a5.4,5.4,0,1,0-10.8-.073v2.7H9a2.257,2.257,0,0,0-2.25,2.25v10.8A2.257,2.257,0,0,0,9,26.775H22.5a2.257,2.257,0,0,0,2.25-2.25v-10.8A2.257,2.257,0,0,0,22.5,11.475Zm-5.962,7.02v3.87a.807.807,0,0,1-.748.81.788.788,0,0,1-.827-.788V18.495a1.8,1.8,0,1,1,1.575,0Zm3.038-7.02h-7.65v-2.7a3.825,3.825,0,0,1,7.65,0Z",
  transform: "translate(-6.75 -3.374)",
  fill: "#fff"
});
function SvgSecuritySelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23.4,
    viewBox: "0 0 18 23.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySelected);
export default __webpack_public_path__ + "static/media/securitySelected.863bbf44802400d7b366b529ad7495cf.svg";
export { ForwardRef as ReactComponent };